import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { LoadingSpinner, PageLayout } from "lib";
import Html5QrcodePlugin from "./Html5QrcodePlugin";
import CheckAttendanceEvent from "./CheckAttendanceEvent";
import { EventsAPI, ParticipantsAPI } from "api_inbusiness";
import ParticipantsList from "./ParticipantsList";

import styles from "./QrAdminPage.module.scss";
import CheckAttendanceCustomEvent from "./CheckAttendanceCustomEvent";

const QrAdminPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [eventData, setEventData] = useState({});
  const [userData, setUserData] = useState("");
  const [openAttendance, setOpenAttendance] = useState(false);
  const [openCustomEvent, setOpenCustomEvent] = useState(false);
  const [scannerKey, setScannerKey] = useState(0); // Key to force re-render of scanner

  const onNewScanResult = (decodedText, decodedResult) => {
    if (decodedText !== "") {
      setUserData(decodedText);
      eventData.custom === true
        ? setOpenCustomEvent(true)
        : setOpenAttendance(true);
      // Don't call clear() - let the modal handle the flow
      // Scanner will be re-rendered with new key when modal closes
    }
  };

  // Re-render scanner when modal closes
  const handleModalClose = (setOpen) => {
    setOpen(false);
    setScannerKey((prev) => prev + 1); // Force scanner to re-render
  };

  const getEvent = () => {
    EventsAPI.getById(id).then((res) => {
      setEventData(res.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    getEvent();
  }, []);

  return (
    <>
      <PageLayout title="Scanează codul QR">
        {loading ? (
          <LoadingSpinner loading={loading} />
        ) : (
          <div className={styles.qrAdminPageContainer}>
            {/* Only render scanner when no modal is open */}
            {!openAttendance && !openCustomEvent && (
              <Html5QrcodePlugin
                key={scannerKey}
                fps={10}
                qrbox={250}
                disableFlip={false}
                qrCodeSuccessCallback={(decodedText, decodedResult) =>
                  onNewScanResult(decodedText, decodedResult)
                }
              />
            )}
          </div>
        )}
      </PageLayout>
      <CheckAttendanceEvent
        open={openAttendance}
        setOpen={(val) => val === false ? handleModalClose(setOpenAttendance) : setOpenAttendance(val)}
        userData={userData}
        eventId={id}
      />

      <CheckAttendanceCustomEvent
        open={openCustomEvent}
        setOpen={(val) => val === false ? handleModalClose(setOpenCustomEvent) : setOpenCustomEvent(val)}
        eventData={eventData}
        qrData={userData}
        eventId={id}
      />
    </>
  );
};

export default QrAdminPage;
